export const staticBaseURL = "https://eflow-static02-landing.s3.us-west-2.amazonaws.com/media/elements/";
export const staticBaseURLAPI7 = "https://eflow-static01.s3-us-west-2.amazonaws.com/media/";
export const recaptchaKey = "6Ld4-wwgAAAAAN0rUQS60-Tk5177HXyfAYaJiHsf";
export const stripePublishableKey = "pk_test_51ObJRmKZ5YCc9rbY2am9tphv5vXnY8A0cVEjUbBNC6NqrL4SN4a5KK1yoDJr92hUKAyBad44NvVb8RD3VSBeYegv0034gCqUVR";
